module.exports = __webpack_public_path__ + "media/images/home/identification-907ff88109e06ab99ae50abea50a188f.png";